export const parseJwt = (token: string): any => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    } catch (e) {
        return null;
    }
};

export const buildLogoutPayload = (
    token: string,
    fallback: { username?: string; roleid?: string | number } = {}
) => {
    const decoded = parseJwt(token);
    return {
        username: decoded?.username || decoded?.Username || fallback.username || "",
        roleid: decoded?.roleid || decoded?.RoleID || decoded?.role || fallback.roleid || "",
        employeeid:
            decoded?.employeeid || decoded?.empid || decoded?.EmployeeID || decoded?.id || "",
    };
};
